var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-sport",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39715",
    "data-name": "Path 39715",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39718",
    "data-name": "Path 39718",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "directions_bike_FILL0_wght600_GRAD0_opsz48",
    d: "M21.45,8.037A2.513,2.513,0,0,1,19.628,7.3a2.427,2.427,0,0,1-.756-1.8,2.455,2.455,0,0,1,.739-1.8A2.5,2.5,0,0,1,21.45,2.95a2.524,2.524,0,0,1,2.544,2.544A2.524,2.524,0,0,1,21.45,8.037Zm-6.7,7.047,3.059,3.231v8.559h-2.2V20l-4.641-4.091a2.343,2.343,0,0,1-.516-.722,2.2,2.2,0,0,1-.241-1,2.073,2.073,0,0,1,.241-.928,2.9,2.9,0,0,1,.516-.756l4.091-4.091a2.623,2.623,0,0,1,.756-.5,2.419,2.419,0,0,1,1.031-.223,2.934,2.934,0,0,1,1.1.206,2.421,2.421,0,0,1,.825.516L21.45,11.1a8.6,8.6,0,0,0,2.217,1.581,6.335,6.335,0,0,0,2.9.653V15.5a8.727,8.727,0,0,1-3.747-.773,10.88,10.88,0,0,1-2.991-2.08L18.494,11.3Zm-7.6,2.75a6.405,6.405,0,0,1,4.709,1.925,6.405,6.405,0,0,1,1.925,4.709,6.349,6.349,0,0,1-1.925,4.692A6.435,6.435,0,0,1,7.15,31.068a6.378,6.378,0,0,1-4.692-1.908A6.378,6.378,0,0,1,.55,24.469a6.435,6.435,0,0,1,1.908-4.709A6.349,6.349,0,0,1,7.15,17.834Zm0,11.241a4.521,4.521,0,0,0,4.606-4.606A4.521,4.521,0,0,0,7.15,19.862a4.521,4.521,0,0,0-4.606,4.606A4.521,4.521,0,0,0,7.15,29.075ZM26.194,17.834a6.349,6.349,0,0,1,4.692,1.925,6.435,6.435,0,0,1,1.908,4.709,6.516,6.516,0,0,1-6.6,6.6,6.435,6.435,0,0,1-4.709-1.908,6.349,6.349,0,0,1-1.925-4.692,6.573,6.573,0,0,1,6.634-6.634Zm0,11.241A4.521,4.521,0,0,0,30.8,24.469a4.521,4.521,0,0,0-4.606-4.606,4.4,4.4,0,0,0-3.266,1.323,4.778,4.778,0,0,0,0,6.566,4.4,4.4,0,0,0,3.266,1.323Z",
    transform: "translate(10.025 6.954)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSport);
export default __webpack_public_path__ + "static/media/ic-sport.e350025af2ac3134def0b4d5ab935cb3.svg";
export { ForwardRef as ReactComponent };